(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('rfGlobalSummernote', [
        '$rootScope', 
        '$timeout', 
        'ResourcesService', 
        'SummernoteBroadcast',
        RfGlobalSummernoteDirectiveFn]);

    // main summernote directive
    function RfGlobalSummernoteDirectiveFn(
        $rootScope, 
        $timeout, 
        ResourcesService, 
        SummernoteBroadcast) {

        var directive = {
            restrict: 'E',
            templateUrl: '/app/global/templates/rf-global-summernote.template.html',
            scope: {
                model: '=',
                type: '@?', // typ (task, appointment, etc) for loading specific predefined-texts
                height: '@',
                toolbar: '@',
                disabled: '@',
                focus: '@?',
                onContextAdd: '&?'
            },
            link: link
        };
        return directive;

        function link(scope, element) {
            // div for summernote container
            var el = element.find("#summer");
            // timeouter
            var timeouter = null;
            // the summernote jquery object
            var summer = null;
            // list of predefined texts 
            scope.predefinedTexts = [];

            var focus = scope.focus === 'true' ? true : false;

            $.extend($.summernote.plugins, {
                'shift.enter': function (context) {
                    this.events = {
                        'summernote.enter': function (we, e) {
                            if (e.shiftKey) {
                                // insert 2 br tags (if only one br tag is inserted the cursor won't go to the next line)
                                document.execCommand('insertHTML', false, '<br><br>');
                                e.preventDefault();
                            }
                        }
                    };
                }
            });

            // activate
            activate();

            // activate
            function activate() {

                var summernoteCallbacks = {
                    onPaste: function (e) {
                        var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                
                        e.preventDefault();
                
                        setTimeout(function(){
                            document.execCommand( 'insertText', false, bufferText );
                        }, 10);
                    }
                };
                
                // because of this summernote issue https://github.com/summernote/summernote/issues/3660, 
                // we keep using a fixed version of summernote (v.0.8.12)
                var hint =  {
                    match: /\*(\d*)/,
                    search: function (keyword, callback) {
                      if (!keyword) {
                        callback(scope.predefinedTexts.map(function(text) {
                         return formatResource(text);  
                        }));
                      } else {
                          var index = parseInt(keyword, 10);
                          if (!isNaN(index) && scope.predefinedTexts[index-1]) {
                              var resource = scope.predefinedTexts[index-1];
                              callback([formatResource(resource)]);
                          }
                      }
                    },
                    content: function (item) {
                        return item.substring(4).trim();
                      } 
                  };

                // options
                if (!scope.disabled) {
                    // admin always full
                    if ($rootScope.isRingfoonAdmin) {
                        // options
                        scope.options = {
                            callbacks: summernoteCallbacks,
                            height: scope.height,
                            dialogsFade: true,
                            focus: focus,
                            airMode: false,
                            dialogsInBody: true,
                            toolbar: [
                                ['headline', ['style']],
                                ['fontface', ['fontname']],
                                ['style', ['bold', 'italic', 'underline', 'superscript', 'subscript', 'strikethrough', 'clear']],
                                ['textsize', ['fontsize']],
                                ['fontclr', ['color']],
                                ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']],
                                ['height', ['height']],
                                ['insert', ['link', 'picture', 'video', 'hr']],
                                ['view', ['fullscreen', 'codeview']],
                                ['help', ['help']]
                            ],
                            hint: hint
                        };
                    } // if
                    else if ($rootScope.isRingfoonOperatorRestricted) {
                        // options
                        scope.options = {
                            callbacks: summernoteCallbacks,
                            height: scope.height,
                            focus: focus,
                            airMode: false,
                            dialogsInBody: true,
                            toolbar: [
                                ['style', ['bold', 'italic', 'underline', 'clear']],
                                ['alignment', ['ul', 'ol', 'paragraph']]
                            ],
                            hint: hint
                        };
                    }
                    else if (scope.toolbar !== undefined && scope.toolbar === 'full') {
                        // If manually Set -> take this

                        // options
                        scope.options = {
                            callbacks: summernoteCallbacks,
                            height: scope.height,
                            dialogsFade: true,
                            focus: focus,
                            airMode: false,
                            dialogsInBody: true,
                            toolbar: [
                                ['headline', ['style']],
                                ['fontface', ['fontname']],
                                ['style', ['bold', 'italic', 'underline', 'superscript', 'subscript', 'strikethrough', 'clear']],
                                ['textsize', ['fontsize']],
                                ['fontclr', ['color']],
                                ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']],
                                ['height', ['height']],
                                ['insert', ['link', 'picture', 'video', 'hr']],
                                ['view', ['fullscreen', 'codeview']],
                                ['help', ['help']]
                            ]
                        };
                    } // else if
                    else if (scope.toolbar !== undefined && scope.toolbar === 'min') {
                        // options
                        scope.options = {
                            callbacks: summernoteCallbacks,
                            height: scope.height,
                            focus: focus,
                            airMode: false,
                            dialogsInBody: true,
                            toolbar: [
                                ['style', ['bold', 'italic', 'underline', 'clear']],
                                ['alignment', ['ul', 'ol', 'paragraph']]
                            ]
                        };
                    } // else if
                    else {
                        // options
                        scope.options = {
                            callbacks: summernoteCallbacks,
                            height: scope.height,
                            focus: focus,
                            airMode: false,
                            dialogsInBody: true,
                            toolbar: [
                                ['style', ['bold', 'italic', 'underline', 'clear']],
                                ['alignment', ['ul', 'ol', 'paragraph']]
                            ]
                        };
                    }

                } // if
                else {
                    // options
                    scope.options = {
                        //height: scope.height,
                        callbacks: summernoteCallbacks,
                        focus: focus,
                        airMode: false,
                        dialogsInBody: true,
                        toolbar: []
                    };
                } // else

                // the summernote jquery object
                summer = el.summernote(scope.options);

                // set content to summernote 
                summer.summernote('code', scope.model);

                if (scope.disabled === "true") { 
                    summer.summernote('disable'); 
                }

                //// only ringfoon have canned-texts
                if ($rootScope.isRingfoon) {
                    // is there a type for loading predefined texts ?
                    if (scope.type) {
                        // depending on type -> load texts 
                        if (scope.type === 'task') {
                            ResourcesService.predefinedTaskTexts().then(function (resources) {
                                var numberedResources = resources.map(function(res, idx) {
                                   return Object.assign(res, {index: idx}); 
                                });
                               
                                scope.predefinedTexts = numberedResources;
                                
                            });
                        } // if
                        else if (scope.type === 'appointment') {
                            ResourcesService.predefinedAppointmentTexts().then(function (resources) {
                                var numberedResources = resources.map(function(res, idx) {
                                    return Object.assign(res, {index: idx}); 
                                 });
                                scope.predefinedTexts = numberedResources;
                            });
                        }
                    }
                }

                if (summer.summernote('isEmpty')) { 
                    scope.model = null; 
                }

                // activate dropdown toggles since, metronic dropdown hover is ÒÒing conflict
                $('.dropdown-toggle').dropdown();

                if (focus) {
                    setTimeout(function() {
                        summer.summernote('focus');
                    }, 0);
                }
            } // activate

            function formatResource(resource) {
                return `${resource.index + 1} - ${resource.translation}`;
            }  

            // set model binding
            function setContent(content) {
                if (summer.summernote('isEmpty')) { 
                    content = null; 
                }
                timeouter = $timeout(function () {
                    scope.model = content;
                }, 0);
            }

            // on change callback
            summer.on('summernote.change', function (we, contents) {
                // set new content
                setContent(contents);
            });

            // take the text and put to model
            scope.take = function (text) {
                // add to content                
                var content = summer.summernote('code');
                content += ' ' + text.translation + '\n';
                content = content.trim();
                // put into summernote
                summer.summernote('code', content);
                // set to model (binding)
                setContent(content);
                // check for callbacks
                // on context add callback
                if (scope.onContextAdd) {
                    scope.onContextAdd({ content: text.keyword });
                }
            };

            // listen on key-down event
            element.on('keydown', function (event) {
                if (event.which === 13) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            });

            // outside watcher
            var watcher = scope.$on(SummernoteBroadcast.Append, function (obj, text) {
                // append to summernote
                summer.summernote('code', summer.summernote('code') + '<br>' + (text || ''));
            });

            // destroy
            scope.$on('$destroy', function () {
                element.off("keydown");
                //element.off("paste");
                summer.off('summernote.change');
                summer.summernote('destroy');
                if (timeouter) {
                    $timeout.cancel(timeouter);
                    timeouter = null;
                } // if

                watcher();
                watcher = null;
            });
        } // link
    }

})();